import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "../data";

const ServiceRow = ({ item, index }) => {
  const [hover, setHover] = useState(false);
  return (
    <Reveal delay={index * 0.05}>
      <div
        data-testid={`service-row-${item.name.toLowerCase().replace(/\s+/g, "-")}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className="group border-t border-foreground/10 py-8 lg:py-10 cursor-default"
      >
        <div className="flex items-start justify-between gap-6">
          <h3 className="font-display font-medium text-3xl lg:text-5xl tracking-tight transition-colors duration-300 group-hover:text-primary">
            {item.name}
          </h3>
          <motion.span
            animate={{ rotate: hover ? 45 : 0, color: hover ? "hsl(var(--primary))" : "rgba(0,0,0,0.35)" }}
            className="mt-1 shrink-0"
          >
            <ArrowUpRight size={28} />
          </motion.span>
        </div>
        <motion.p
          initial={false}
          animate={{ height: hover ? "auto" : 0, opacity: hover ? 1 : 0, marginTop: hover ? 16 : 0 }}
          className="overflow-hidden font-body text-base lg:text-lg text-foreground/60 max-w-lg"
        >
          {item.desc}
        </motion.p>
      </div>
    </Reveal>
  );
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-10 lg:py-14 px-6 lg:px-12">
      <Reveal className="mb-10 lg:mb-16 max-w-3xl">
        <p className="inline-block bg-primary text-primary-foreground px-4 py-2 text-xs sm:text-sm uppercase tracking-[0.25em] font-bold">What we do</p>
        <h2 className="mt-6 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter leading-[0.95]">
          One Creative Agency.
          <br />
          Two Core Strengths.
        </h2>
      </Reveal>

      <div className="flex flex-col gap-16 lg:gap-24">
        {SERVICES.map((svc) => (
          <div key={svc.group} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-28">
                <span className="text-lg lg:text-2xl uppercase tracking-[0.15em] text-primary font-bold">{svc.tag}</span>
                <h3 className="mt-4 font-display font-extrabold text-6xl lg:text-[6vw] uppercase tracking-tighter leading-[0.85]">
                  {svc.group}
                </h3>
                <div className="mt-6 h-px w-24 bg-primary" />
              </div>
            </div>
            <div className="lg:col-span-7 lg:col-start-6">
              {svc.items.map((item, i) => (
                <ServiceRow key={item.name} item={item} index={i} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
